<ngx-zero-state class="user-session-expiration-zero-state">
	<p zero-state-title translate="user-session-expiration_you_have_been_signed_out"></p>
	<p zero-state-subtext translate="user-session-expiration_return_to_home_page"></p>
</ngx-zero-state>
